/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const campaignDataStatusSchema = z.enum(['draft', 'review', 'publishing', 'active', 'completed'])

export type CampaignDataStatusSchema = z.infer<typeof campaignDataStatusSchema>
